import { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { AppSingleton } from "../services/user_config";
import { Chess } from "chess.js";
import { Chessboard } from "react-chessboard";
// https://www.npmjs.com/package/cm-chessboard

const GameWesternChessSection = () => {
  console.log("Chess");
  console.log(Chess);
  const appSingleton = new AppSingleton();
  const [game, setGame] = useState(new Chess());

  function makeAMove(move) {
    // const gameCopy = { ...game };
    const gameCopy = new Chess(game.fen());
    const result = gameCopy.move(move);
    setGame(gameCopy);
    return result; // null if the move was illegal, the move object if the move was legal
  }

  function makeRandomMove() {
    const possibleMoves = game.moves();
    if (game.game_over() || game.in_draw() || possibleMoves.length === 0)
      return; // exit if the game is over
    const randomIndex = Math.floor(Math.random() * possibleMoves.length);
    makeAMove(possibleMoves[randomIndex]);
  }

  const onDrop = (sourceSquare, targetSquare) => {
    const move = makeAMove({
      from: sourceSquare,
      to: targetSquare,
      promotion: "q",
    });

    // illegal move
    if (move === null) return false;
    setTimeout(makeRandomMove, 200);
    return true;
  };

  return (
    <Box sx={{ pt: 4 }}>
      <Typography variant="h3" sx={{ textAlign: "center", m: 4 }}>
        國際象棋
      </Typography>
      <Chessboard
        position={game.fen()}
        onPieceDrop={onDrop}
        customBoardStyle={{
          borderRadius: "4px",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.5)",
        }}
      />
    </Box>
  );
};

export { GameWesternChessSection };
